import PartnerScorecardContext from './PartnerScorecardContext'
import withPartnerScorecardContext from './withPartnerScorecardContext'

export {withPartnerScorecardContext}
export default PartnerScorecardContext